export default "__VITE_ASSET__xYl0XnO2__"